
import { nodeHelpers } from '@/components/mixins/nodeHelpers';

import AliareInput from '@/components/AliareInput.vue';
import mixins from 'vue-typed-mixins';

export default mixins(
	nodeHelpers,
).extend({
	components: {
		AliareInput,
	},
	props: {
		dataInput: {
			type: Object,
		},
	},
	data() {
		return {
			isLoadingWorkflow: false,
			isLoadingMore: false,
			flowSelected: '',
			workflowList: [],
			oldSearch: '',
			projectSelected: '',
			searched: false,
			showSelect: false,
			searchWorkflow: '',
			page: 1,
			pageSize: 5,
			scrollInfinite: true,
		};
	},
	computed: {
		isEdit() {
			if (this.dataInput.item?.workflow?.id) {
				return true;
			} else {
				return;
			}
		},
		workspace() {
			return this.$store.getters.workspace;
		},
	},
	methods: {
		disableInput() {
			this.showSelect = false;
		},

		searchInfoByName:
		_.debounce(async function (e)  {
			let firstFocus = false;

			if (!this.workflowList.length) {
				firstFocus = true;
			}

			if (firstFocus || this.searchWorkflow.length > 2 && this.oldSearch !== this.searchWorkflow || !firstFocus && this.searchWorkflow.length < 2) {
				this.page = 1;
				this.scrollInfinite = true;
				await this.getWorkflowsList(false);
				this.oldSearch = JSON.parse(JSON.stringify(this.searchWorkflow));
				this.searched = true;
			}
		}, 500),
		async getWorkflowsList(append = false) {
			if (append) {
				this.isLoadingMore = true;
			} else {
				this.isLoadingWorkflow = true;
			}

			try {
				const response = await this.restApi().getWorkflows(this.workspace.id, {
					nome: this.searchWorkflow,
					page: this.page,
					size: this.pageSize,
					BuscarFluxosFonteDeDados: true,
					Ativo: true,
					Automatico: false,
				});

				if (append) {
					// Evita duplicatas e trava o scroll caso o endpoint ignore o "page"
					const existingIds = new Set(this.workflowList.map((w: any) => w.id));
					const newItems = response.filter((w: any) => !existingIds.has(w.id));

					if (!newItems.length) {
						this.scrollInfinite = false;
					} else {
						this.workflowList.push(...newItems);
					}
				} else {
					this.workflowList = response;
				}

				// Última página: veio menos que o tamanho de página
				if (!response.length || response.length < this.pageSize) {
					this.scrollInfinite = false;
				}
			} catch (e) {
				console.log(e);
				this.scrollInfinite = false;
			} finally {
				this.isLoadingWorkflow = false;
				this.isLoadingMore = false;
			}
		},
		async loadMoreWorkflows() {
			if (!this.scrollInfinite || this.isLoadingMore || this.isLoadingWorkflow) return;
			this.page++;
			await this.getWorkflowsList(true);
		},
		onWorkflowListScroll(event: any) {
			const el = event.target;
			if (el.scrollTop + el.clientHeight >= el.scrollHeight - 40) {
				this.loadMoreWorkflows();
			}
		},
		activeSearch() {
			this.showSelect = !this.showSelect;
			this.$nextTick(() => {
				this.$refs.aliareInput.$refs.input.focus();
			});
		},
		selectedWorkflow(info) {
			this.showSelect = !this.showSelect;
			this.flowSelected = info;
			this.projectSelected = info.projeto.nome;
			if (this.dataInput) {
				this.$emit('selected', {id: info.id, item: JSON.parse(JSON.stringify(this.dataInput))});
			}
		},
		async loadCurrentWorkflow() {
			if (this.isEdit) {
				this.isLoadingWorkflow = true;

				const currentWorkflow = await this.restApi().getWorkflows(this.workspace.id, {
					id: this.dataInput.item.workflow.id,
				});

				this.flowSelected = currentWorkflow[0];
				this.projectSelected = currentWorkflow[0].projeto.nome;
				this.$emit('selected', {id: currentWorkflow[0].id, item: JSON.parse(JSON.stringify(this.dataInput))});

				this.isLoadingWorkflow = false;
			} else {
				return;
			}
		},
	},
	created() {
		this.loadCurrentWorkflow();
	},
});
